export default {
  inventories: `/v1/inventories/inventories`,
  inventories_paginate: `/v1/inventories/paginate`,
  inventory: (id: string) => `/v1/inventories/inventories/${id}`,
  block_skills: (id: string) => `/v1/inventories/inventories/${id}/block_skills`
};
